/**
 * Pause/play controls for auto-moving content (see snippets/motion-toggle.liquid).
 * - Video: toggles the <video> elements inside the button's [data-motion-root].
 * - Marquee: toggles the Web Animations that <marquee-text> runs on its scroller.
 * People who set "reduce motion" in their OS start paused; the button lets them opt in.
 */
(function () {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function getTargets(root, kind) {
    if (kind === 'video') {
      return Array.prototype.slice.call(root.querySelectorAll('video'));
    }

    var marquee = root.querySelector('marquee-text');
    var scroller = marquee && marquee.shadowRoot && marquee.shadowRoot.querySelector('[part="scroller"]');
    return scroller ? scroller.getAnimations() : [];
  }

  function isPlaying(target) {
    return typeof target.paused === 'boolean' ? !target.paused : target.playState === 'running';
  }

  function setState(button, state) {
    button.setAttribute('data-state', state);
    button.setAttribute('aria-label', button.getAttribute(state === 'playing' ? 'data-label-pause' : 'data-label-play'));
  }

  function toggle(button) {
    var root = button.closest('[data-motion-root]');
    if (!root) return;

    var targets = getTargets(root, button.getAttribute('data-motion-kind'));
    var shouldPause = button.getAttribute('data-state') === 'playing';

    targets.forEach(function (target) {
      if (shouldPause) {
        target.pause();
      } else {
        var result = target.play();
        if (result && result.catch) result.catch(function () {});
      }
    });

    setState(button, shouldPause ? 'paused' : 'playing');
  }

  function applyReducedMotion() {
    if (!reducedMotion.matches) return;

    document.querySelectorAll('[data-motion-toggle]').forEach(function (button) {
      var root = button.closest('[data-motion-root]');
      if (!root) return;

      if (button.getAttribute('data-motion-kind') === 'video') {
        getTargets(root, 'video').forEach(function (video) {
          video.removeAttribute('autoplay');
          video.pause();
        });
      }

      // The marquee is paused by theme.js when it starts; only the button state needs to match.
      setState(button, 'paused');
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-motion-toggle]');
    if (button) toggle(button);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyReducedMotion);
  } else {
    applyReducedMotion();
  }
})();
